var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLynxLogomarkColourRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F8CD8B;}\r\n\t.st1{fill:#F6BC65;}\r\n\t.st2{fill:#F3A738;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "241.56,232.67 241.56,223.52 223.18,223.52 223.18,276.33 232.4,276.33 232.4,232.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "276.76,214.36 241.56,214.36 241.56,223.52 258.39,223.52 258.39,232.67 267.61,232.67  267.61,267.17 276.76,267.17  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.56,
    y: 223.52,
    className: "st1",
    width: 16.83,
    height: 9.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "258.39,276.33 232.4,276.33 232.4,285.48 267.61,285.48 267.61,267.17 258.39,267.17  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.39,
    y: 232.67,
    className: "st1",
    width: 9.22,
    height: 34.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.56,
    y: 232.67,
    className: "st2",
    width: 16.83,
    height: 34.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynxLogomarkColourRgb);
export default __webpack_public_path__ + "static/media/Lynx-logomark-colour-rgb.1e04bc8abeb31c8a654a4879d87f2704.svg";
export { ForwardRef as ReactComponent };